import { MultiSort } from "@dialogs/select-sort/select-sort.component";

export class SavedSortView {
    sortId: string;
    caseId: string;
    createdByUserId: string;
    createdDateTime: string;
    displayTitle: string;
    sortDetails: MultiSort;
}